<script lang="ts">
  import type { CategoryPropConfig } from '../../modules/projects/project.interface';
  import { TextField } from 'svelte-materialify';

  export let value: string;
  export let categoryPropConfig: CategoryPropConfig;
</script>

<TextField bind:value outlined>
  {#if !categoryPropConfig.isOptional}
    <span>*</span>
  {/if}
  <span> {categoryPropConfig.name} </span>
</TextField>
